import { render } from "./ComplianceOverview.vue?vue&type=template&id=63f83b04&scoped=true"
import script from "./ComplianceOverview.vue?vue&type=script&lang=js"
export * from "./ComplianceOverview.vue?vue&type=script&lang=js"

import "./ComplianceOverview.vue?vue&type=style&index=0&id=63f83b04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f83b04"]])

export default __exports__